var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"0","pointer-events":"none","touch-action":"none"},attrs:{"src":"https://comics.3and3.dev/comics","width":_vm.width,"height":_vm.height,"scrolling":"no"}})}
var staticRenderFns = []

export { render, staticRenderFns }